function toggleFromLabelByCurrentPrice() {
  document.querySelectorAll('.price-wrapper[data-price-min]').forEach((wrap) => {
    const min = parseInt(wrap.getAttribute('data-price-min'), 10);
    const fromLabel = wrap.querySelector('.from-label');
    const priceEl = wrap.querySelector('.price');
    if (!fromLabel || !priceEl) return;

    const text = priceEl.textContent || '';
    const current = parseInt(text.replace(/[^\d]/g, ''), 10);
    if (!Number.isFinite(current) || !Number.isFinite(min)) return;

    fromLabel.style.display = (current === min) ? '' : 'none';
  });
}

document.addEventListener('DOMContentLoaded', toggleFromLabelByCurrentPrice);

document.addEventListener('variant:change', toggleFromLabelByCurrentPrice);

document.addEventListener('change', (e) => {
  if (e.target.closest('form')) {
    setTimeout(toggleFromLabelByCurrentPrice, 50);
  }
});